import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config/config.service';
import {
  PdvAtualizarItensRequest,
  PdvCriarRequest,
  PdvFinalizarResponse,
  PdvVenda,
  ProdutoPdv,
} from '../models/ponto-de-venda.model';

@Injectable({ providedIn: 'root' })
export class PontoDeVendaService {

  private readonly http          = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  private get apiUrl(): string {
    return this.configService.settings()?.apiUrl ?? '';
  }

  private get vendasUrl(): string {
    return `${this.apiUrl}/financeiro/pdv/vendas`;
  }

  /** GET /cadastro/produto/codigo-barra/{codigo} */
  buscarProdutoPorCodigoBarra(codigo: string): Observable<ProdutoPdv> {
    return this.http.get<ProdutoPdv>(
      `${this.apiUrl}/cadastro/produto/codigo-barra/${encodeURIComponent(codigo)}`,
    );
  }

  /** POST /financeiro/pdv/vendas (idempotente por chaveIdempotencia). */
  criar(request: PdvCriarRequest): Observable<PdvVenda> {
    return this.http.post<PdvVenda>(this.vendasUrl, request);
  }

  /** GET /financeiro/pdv/vendas/em-andamento (rascunhos do usuário do token). */
  emAndamento(): Observable<PdvVenda[]> {
    return this.http.get<PdvVenda[]>(`${this.vendasUrl}/em-andamento`);
  }

  /** PUT /financeiro/pdv/vendas/{id}/itens (substitui o snapshot; totais vêm do servidor). */
  atualizarItens(id: number, request: PdvAtualizarItensRequest): Observable<PdvVenda> {
    return this.http.put<PdvVenda>(`${this.vendasUrl}/${id}/itens`, request);
  }

  /** POST /financeiro/pdv/vendas/{id}/finalizar */
  finalizar(id: number): Observable<PdvFinalizarResponse> {
    return this.http.post<PdvFinalizarResponse>(`${this.vendasUrl}/${id}/finalizar`, {});
  }

  /** POST /financeiro/pdv/vendas/{id}/reabrir */
  reabrir(id: number): Observable<PdvVenda> {
    return this.http.post<PdvVenda>(`${this.vendasUrl}/${id}/reabrir`, {});
  }

  /** POST /financeiro/pdv/vendas/{id}/cancelar (idempotente). */
  cancelar(id: number): Observable<void> {
    return this.http.post<void>(`${this.vendasUrl}/${id}/cancelar`, {});
  }
}
